export const EMPTY_STRING = '';
export const EMPTY_ARRAY = [];
export const EMPTY_NUMBER = 0;
export const SPACE = ' ';
export const HASH = '#';
export const COMMA = ',';
export const EMPTY_BLOCK = <></>;